import FileMetaDTO from "@/dto/files/FileMetaDTO";

export default class PageFileDTO {

    public pageNumber!: number;
    public pageFile!: FileMetaDTO;

}
